module.exports = __webpack_public_path__ + "static/media/tiptap.8bfe3533.svg";